module.exports = __webpack_public_path__ + "img/ps-logo.eca3c49c.png";